import { z } from 'zod'
import { HouseholdId, SessionId, UserId } from './ids.ts'

export const Session = z.object({
	id: SessionId,
	userId: UserId,
	householdId: HouseholdId,
	createdAt: z.iso.datetime(),
	expiresAt: z.number().int().positive(),
})
export type Session = z.infer<typeof Session>
